/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { Button, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";
import DialogBase from "../../Components/DialogBase";
import { translationKeys, useTranslation } from "./../../Internationalisierung/i18nBasis";
import AppAboutDialogModel from "./AppAboutDialogModel";
import AppAboutDialogProps from "./AppAboutDialogProps";

export default function AppAboutDialog(props: AppAboutDialogProps) {
    const vm = new AppAboutDialogModel(props);
    const { t } = useTranslation();
    return (
        <DialogBase open={vm.isOpen}>
            <DialogTitle>{t(translationKeys.appAboutDialog.caption)}</DialogTitle>
            <DialogContent>
                <Typography>{`${t(translationKeys.appAboutDialog.version)} ${vm.version}`}</Typography>
                <Typography>{`${t(translationKeys.appAboutDialog.instanz)} ${vm.instanzId}`}</Typography>
                <Typography>{t(translationKeys.appAboutDialog.copyright)}</Typography>
                <TextField
                    value={vm.licenses}
                    label={t(translationKeys.appAboutDialog.licenseInformation)}
                    multiline
                    rows={10}
                    InputProps={{ readOnly: true, }}
                    fullWidth
                    margin='normal'
                    variant='outlined'
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={vm.ok} color="primary">
                    {t(translationKeys.appAboutDialog.ok)}
                </Button>
            </DialogActions>
        </DialogBase>
    );
}
